import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from "vue";

// Classes
import { ClubAdvantage } from "../classes/ClubAdvantage";

// Components
import BorderHorizontal from "@/vue/common/borderHorizontal.vue";

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultPopUp',
  props: {
    advantage: null
  },
  emits: ["closePopup"],
  setup(__props: any, { emit }: { emit: ({
	(e: "closePopup"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	advantage: ClubAdvantage;
};





// Methods
const handleClose = (): void => {
	emit("closePopup");
};

return { __sfc: true,props, emit, handleClose, BorderHorizontal }
}

})